<mat-grid-list cols="2" rowHeight="40px" style="width: 700px; max-width: 100%; height: 100%; ">
  <div *ngFor="let preferences of (notificationPreferences$ | async)">
    <mat-grid-tile>
      {{ 'account.menu.email_notifications.notificationTriggers.' + preferences.notificationTrigger | translate }}
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-checkbox [(ngModel)]="preferences.emailChannelEnabled"
                    (change)="onPreferencesChanged(preferences)"></mat-checkbox>
    </mat-grid-tile>
  </div>
</mat-grid-list>
